import { ArrowLeft } from 'lucide-react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { ModaleControleCerfa } from '../components/contrats/ModaleControleCerfa';
import { useToast } from '../components/ui/useToast';
import { useRafraichirContrats } from '../lib/useContrats';

/**
 * Espace de préparation d'un contrat : volontairement une page, pas une
 * fenêtre. La personne conserve le contexte de l'application, peut lire le
 * parcours sans contrainte de hauteur et revenir à la liste naturellement.
 */
export function AdmContratFormulairePage(): JSX.Element {
  const { immersionId } = useParams();
  const naviguer = useNavigate();
  const notifier = useToast();
  const rafraichir = useRafraichirContrats();

  const retour = (): void => naviguer('/adm-contrats-apprentissage');

  if (!immersionId) {
    return <Navigate to="/adm-contrats-apprentissage" replace />;
  }

  return (
    <div className="min-h-full">
      <div className="mx-auto max-w-7xl px-4 py-5 sm:px-6 lg:py-8">
        <button
          type="button"
          onClick={retour}
          className="mb-4 -ml-2 inline-flex min-h-[44px] items-center gap-2 rounded-xl px-2 py-2 text-sm font-semibold text-codialis-gray transition hover:bg-white hover:text-codialis-navy"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden />
          Contrats d’apprentissage
        </button>
        <ModaleControleCerfa
          immersionId={immersionId}
          integree
          onFermer={retour}
          // Après la génération, on reste sur le contrat : le CERFA s'y ouvre,
          // et l'état affiché est déjà celui de la base. La liste est
          // rafraîchie en même temps, pour être juste au retour.
          onValide={(message) => {
            void rafraichir();
            notifier(message);
          }}
          onBrouillonEnregistre={(message) => {
            void rafraichir();
            notifier(message);
          }}
        />
      </div>
    </div>
  );
}
